import { cartInitialState } from "./cartItemInitial";

export const cartItemReducer = (state = cartInitialState, action: any) => {
  switch (action.type) {
    case "addItem":
      return {
        ...state,
        cartItem: [...action.payload],
        orderId: action.orderId
      };
    case "deleteItem":
      return {
        ...state,
        cartItem: [],
        orderId: ""
      };
    case "editItem":
      return {
        ...state,
        cartItem: [...action.payload],
        orderId: action.orderId
      };
    case "holdItem":
      return {
        ...state,
        cartItem: [action.payload],
        orderId: action.orderId
      };
    default:
      return state;
  }
}